import * as React from 'react';
import { FieldArray } from 'react-final-form-arrays';
import HorizonExaminedHistory from 'src/models/tract_detail/HorizonExaminedHistory';
import { FormApi, FieldState, AnyObject } from 'final-form';
import ExaminedHistoryChanges from 'src/models/tract_detail/ExaminedHistoryChanges';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import Form from 'src/components/controls/forms/Form';
import FormRow from 'src/components/controls/forms/FormRow';
import * as _ from 'lodash';

import './ExaminedHistory.scss';
import moment from 'moment';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import { SelectItem } from 'src/models/common/SelectItem';
import FormTextBox, { FormTextBoxDataType } from 'src/components/controls/forms/redesign/FormTextbox';
import { FormErrors } from 'src/util/FormErrors';

export interface IExaminedHistoryProps {
    dialogName: string;
    examinedHistory: Array<HorizonExaminedHistory> | undefined;
    horizonId: number;
    hideDialog: () => void;
    onSaveExaminedHistory: (examinedHistoryChanges: ExaminedHistoryChanges) => void;
}

class ExaminedHistory extends React.Component<IExaminedHistoryProps> {
    private form: FormApi;

    private examinedHistoryChanges = new ExaminedHistoryChanges();

    examinationTypes = [
        new SelectItem('Lease Check', 'Lease Check'),
        new SelectItem('Cursory Ownership', 'Cursory Ownership'),
        new SelectItem('Full Ownership', 'Full Ownership'),
        new SelectItem('Runsheet', 'Runsheet'),
        new SelectItem('Title Opinion', 'Title Opinion'),
        new SelectItem('Third Party Ownership', 'Third Party Ownership'),
        new SelectItem('Tax Records', 'Tax Records'),
        new SelectItem('Brine Title', 'Brine Title'),
        new SelectItem('Updated Third Party Ownership', 'Updated Third Party Ownership'),
    ];

    onSaveExaminedHistory = (examinedHistoryChanges: ExaminedHistoryChanges) => {
        this.props.onSaveExaminedHistory(this.examinedHistoryChanges);
    };

    validate = (values: AnyObject) => {
        const individualValue = values?.history;
        const errors: AnyObject = {};

        individualValue?.map((v: AnyObject) => {
            if (!v.examinedDate) {
                errors.examinedDate = 'Report Date is required!';
            }
            if (!v.examinedByLandman) {
                errors.examinedByLandman = 'Examined By is required!';
            }
            if (!v.ownershipType) {
                errors.ownershipType = 'Examination Type is required!';
            }
            if (!v.recordTypeId) {
                errors.recordTypeId = 'Record Type is required!';
            }
            if (v.recordTypeId === 1) {
                if (!v.book) {
                    errors.book = 'Book is required!';
                }
                if (!v.page) {
                    errors.page = 'Page is required!';
                }
            }

            if (v.recordTypeId === 2) {
                if (!v.instrumentNumber) {
                    errors.instrumentNumber = 'Instrument Number is required!';
                }
            }
        });

        return errors as FormErrors;
    };

    onSubmit = (values: Array<object>, form: FormApi) => {
        const regex = new RegExp('[0-9]');
        // tslint:disable-next-line:no-any
        const formDirtyFields = Object.keys((form.getState() as any).dirtyFields);

        const dirtyRecords = formDirtyFields.map((dirtyField) => {
            if (String(dirtyField).match(regex) !== null || String(dirtyField).match(regex)) {
                const historyIndex = String(dirtyField).match(regex)[0];
                return (
                    // tslint:disable-next-line:no-string-literal
                    values['history'][historyIndex]
                );
            }
        });

        Array.from(new Set(dirtyRecords)).map((dirtyRecord) => {
            if (dirtyRecord) {
                const dirtyClone = _.cloneDeep(dirtyRecord);

                if (dirtyClone.takeOffDate) {
                    dirtyClone.takeOffDate = moment(dirtyClone.takeOffDate).toDate();
                }

                if (dirtyClone.examinedDate) {
                    dirtyClone.examinedDate = moment(dirtyClone.examinedDate).toDate();
                }

                if (dirtyClone.id === undefined) {
                    dirtyClone.createdDate = moment().utc().toDate();
                    this.examinedHistoryChanges.adds.push(dirtyClone);
                } else {
                    this.examinedHistoryChanges.updates.push(dirtyClone);
                }
            }
        });

        this.onSaveExaminedHistory(this.examinedHistoryChanges);
        this.props.hideDialog();
        this.examinedHistoryChanges = new ExaminedHistoryChanges();
    };

    // tslint:disable-next-line:no-any
    onRemove = (form: FormApi, index: number, fields: { remove: (index: number) => any } & FieldState<AnyObject>) => {
        const formValues: AnyObject = form.getState().values;

        // tslint:disable-next-line:no-string-literal
        this.examinedHistoryChanges.deleteIds.push(formValues.history[index]['id']);

        fields.remove(index);
    };

    public render() {
        const recordTypeItems = [
            { id: 1, name: 'Book/Volume' },
            { id: 2, name: 'Instrument #' },
        ];

        const examinedHistory = this.props?.examinedHistory?.map((x) => {
            return {
                ...x,
                examinedDate: moment(new Date(x.examinedDate)).format('YYYY-MM-DD'),
                takeOffDate: moment(new Date(x.takeOffDate)).format('YYYY-MM-DD'),
            };
        });
        return (
            <Dialog dialogName={this.props.dialogName} title="Title Examination History" onCloseDialog={() => this.props.hideDialog()}>
                <div>
                    <Form
                        onFormCreated={(form) => {
                            this.form = form;
                        }}
                        onSubmit={this.onSubmit}
                        hasFieldArray={true}
                        initialValues={{
                            history: examinedHistory,
                        }}
                        validate={this.validate}
                    >
                        <>
                            <div style={{ minHeight: '40rem', maxHeight: '50rem', overflow: 'auto' }}>
                                <FieldArray name="history">
                                    {({ fields, meta }) =>
                                        fields.map((name, index) => {
                                            const recordTypeId = fields?.value[index]?.recordTypeId || 0;

                                            return (
                                                <div key={name} style={{ minWidth: '130rem', paddingBottom: '1rem', borderBottom: '1px solid #ccc' }}>
                                                    <FormRow>
                                                        <FormTextBox
                                                            name={`${name}.examinedDate`}
                                                            label="Report Date"
                                                            className="examined-history-field"
                                                            type={FormTextBoxDataType.Date}
                                                            isRequired={true}
                                                        />
                                                        <FormTextBox
                                                            name={`${name}.examinedByLandman`}
                                                            label="Examined By"
                                                            className="lh-fifth-width examined-history-field"
                                                            isRequired={true}
                                                        />
                                                        <FormTextBox
                                                            name={`${name}.takeOffDate`}
                                                            label="Certification Date"
                                                            className="examined-history-field"
                                                            type={FormTextBoxDataType.Date}
                                                        />
                                                        <FormSelect
                                                            name={`${name}.ownershipType`}
                                                            label="Examination Type"
                                                            className="lh-fifth-width examined-history-field"
                                                            style={{ minWidth: '22rem' }}
                                                            items={this.examinationTypes}
                                                            isRequired={true}
                                                        />
                                                        <FormSelect
                                                            name={`${name}.recordTypeId`}
                                                            label="Record Type"
                                                            items={recordTypeItems}
                                                            style={{ minWidth: '16rem' }}
                                                            className="lh-fifth-width"
                                                            isRequired={true}
                                                        />
                                                        {recordTypeId === 0 && (
                                                            <>
                                                                <div className="lh-fifth-width" />
                                                                <div className="lh-fifth-width" />
                                                            </>
                                                        )}
                                                        {recordTypeId === 1 && (
                                                            <>
                                                                <FormTextBox
                                                                    name={`${name}.book`}
                                                                    label="Book"
                                                                    isRequired={recordTypeId === 1}
                                                                    isDisabled={recordTypeId !== 1}
                                                                    className="lh-fifth-width"
                                                                />

                                                                <FormTextBox
                                                                    name={`${name}.page`}
                                                                    label="Page"
                                                                    isRequired={recordTypeId === 1}
                                                                    isDisabled={recordTypeId !== 1}
                                                                    className="lh-fifth-width"
                                                                />
                                                            </>
                                                        )}
                                                        {recordTypeId === 2 && (
                                                            <>
                                                                <FormTextBox
                                                                    name={`${name}.instrumentNumber`}
                                                                    label="Instrument #"
                                                                    isRequired={recordTypeId === 2}
                                                                    isDisabled={recordTypeId !== 2}
                                                                    className="lh-fifth-width"
                                                                />
                                                                <div className="lh-fifth-width" />
                                                            </>
                                                        )}
                                                        <div
                                                            className="delete-examined-history"
                                                            onClick={() => this.onRemove(this.form, index, fields)}
                                                            style={{ padding: '1.4rem 0' }}
                                                        >
                                                            <i className="fas fa-trash" />
                                                        </div>
                                                    </FormRow>
                                                </div>
                                            );
                                        })
                                    }
                                </FieldArray>
                            </div>
                            <div style={{ marginTop: '5px' }}>
                                <Button
                                    onClick={() => this.form.mutators.push('history', { horizonId: this.props.horizonId })}
                                    text="Add Entry"
                                    intent="success"
                                />
                            </div>

                            <hr />

                            <div style={{ display: 'flex' }}>
                                <FormRow align="right">
                                    <Button intent="primary" type="submit" text="Save" />
                                    <Button intent="warning" onClick={() => this.props.hideDialog()} text="Cancel" />
                                </FormRow>
                            </div>
                        </>
                    </Form>
                </div>
            </Dialog>
        );
    }
}

export default ExaminedHistory;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ExaminedHistory.tsx